import React, { Component } from 'react'
import { translate } from 'react-i18next'
import cookie from 'react-cookies'

// COMPONENTS
import Line from '../components/line/line.component'

// SECTIONS
import Cookies from '../components/cookies/cookies.component'
import Banner from '../sections/banner/banner.section'
import Join from '../sections/join/join.component'
import Recipients from '../sections/recipients/recipients.section'
import Advantages from '../sections/advantages/advantages.section'
import Studies from '../sections/studies/studies.section'
import Practices from '../sections/practices/practices.component'
import Platform from '../sections/platform/platform.component'
import More from '../sections/more/more.component'
import Tabs from '../sections/tabs/tabs.section'

class Home extends Component {
  constructor () {
    super()
    this.state = {
      approved: cookie.load('approved')
    }
  }

  setApproved = () => {
    this.setState({
      approved: true
    })
  }

  render () {
    let {t, i18n} = this.props
    const approved = this.state.approved
    return (
      <div className='top'>
        {
          !approved &&
            <Cookies t={t} i18n={i18n} setApproved={this.setApproved} />
        }
        <Banner id='banner' type={0} t={t} />
        <Join t={t} id='join' />
        <Line />
        <Recipients t={t} id='recipients' />
        <Advantages t={t} id='advantages' />
        <Tabs t={t} i18n={i18n} />
        <Studies t={t} id='studies' />
        <Line />
        <Practices t={t} id='practices' />
        <Line />
        <Platform t={t} id='platform' />
        <More t={t} id='more' i18n={i18n} />
      </div>
    )
  }
}

export default translate('translations')(Home)



// WEBPACK FOOTER //
// ./src/pages/home.page.js